import { FC, useCallback, useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { ActiveMember, TableMemberStatus } from '../types/members-types';
import { Avatar, Box, IconButton } from '@mui/material';
import { MdMoreVert as MoreVertIcon } from 'react-icons/md';
import RoleChips from './RoleChips';
import StatusChip from './StatusChip';
import ActiveMemberMenu from './ActiveMemberMenu';
import { MouseEvent } from 'react';
import {
  openUpdateUserRolesModal,
  setSelectedMember,
} from '../store-actions/update-user-roles-store-actions';
import {
  openRemoveMemberModal,
  setIsMemberAdmin,
  setSelectedMemberToRemove,
} from '../store-actions/remove-member-store-actions';

export interface IMembersTableRowProps {
  activeMember: ActiveMember;
  isReadOnlyUser: boolean;
  isSelf: boolean;
}

const MemberTableRow: FC<React.PropsWithChildren<IMembersTableRowProps>> = ({
  activeMember,
  isReadOnlyUser,
  isSelf,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleEditRoles = useCallback(() => {
    if (!activeMember) {
      return;
    }
    setSelectedMember(activeMember);
    openUpdateUserRolesModal();
  }, [activeMember]);

  const handleRemoveMember = useCallback(() => {
    if (!activeMember) {
      return;
    }
    setSelectedMemberToRemove(activeMember);
    setIsMemberAdmin(activeMember);
    openRemoveMemberModal();
  }, [activeMember]);

  return (
    <>
      <TableRow hover role='checkbox' tabIndex={-1}>
        <TableCell>
          <Box display='flex' alignItems='center' gap={2} ml={2}>
            <Avatar alt={activeMember.name} src={activeMember.picture} />
            {activeMember.name}
          </Box>
        </TableCell>
        <TableCell>{activeMember.email}</TableCell>
        <TableCell>
          <RoleChips roles={activeMember.roles} />
        </TableCell>
        <TableCell>
          <StatusChip
            label={TableMemberStatus.Active}
            tooltipTitle='Active member'
            color='success'
          />
        </TableCell>
        <TableCell onClick={handleMenuClick}>
          <IconButton disabled={isReadOnlyUser && !isSelf}>
            <MoreVertIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <ActiveMemberMenu
        id={activeMember.user_id}
        open={open && (!isReadOnlyUser || (isReadOnlyUser && isSelf))}
        anchorEl={anchorEl}
        handleClose={handleMenuClose}
        handleEditRoles={handleEditRoles}
        handleRemoveMember={handleRemoveMember}
        isReadOnlyUser={isReadOnlyUser}
        isSelf={isSelf}
      />
    </>
  );
};

export default MemberTableRow;
